'use client'

import { MouseEvent } from 'react'
import { useInView } from 'react-intersection-observer'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ProductItem } from '@marketplace-web/item-box/item-box-feature'

import {
  ClosetPromotionItemDto,
  transformClosetPromotionItemDtoToProductItem,
  impressionEvent,
} from '@marketplace-web/vas/vas-data'

type Props = {
  item: ClosetPromotionItemDto
  onClick: (event: MouseEvent) => void
  onItemFavouriteToggle?: React.ComponentProps<typeof ProductItem>['onFavouriteToggle']
  showPhotoCollage: boolean
  index: number
  homepageSessionId?: string
  isViewingSelf: boolean
  isPreview: boolean
}

const ClosetItem = ({
  item,
  onClick,
  onItemFavouriteToggle,
  showPhotoCollage,
  index,
  homepageSessionId,
  isViewingSelf,
  isPreview,
}: Props) => {
  const { track } = useTracking()
  const { ref } = useInView({
    triggerOnce: true,
    onChange: inView => {
      if (!inView) return
      track(
        impressionEvent({
          id: item.id,
          position: index + 1,
          contentType: 'item',
          contentSource: isPreview ? 'promoted_closets_preview' : 'promoted_closets',
          itemOwnerId: item.user_id,
          homepageSessionId,
        }),
      )
    },
  })

  return (
    <div ref={ref} className="u-fill-height" data-testid={`closet-item-${item.id}`}>
      <ProductItem
        item={transformClosetPromotionItemDtoToProductItem(item)}
        onClick={onClick}
        onFavouriteToggle={onItemFavouriteToggle}
        testId={`item-${item.id}`}
        hideBusinessBadge
        showPhotoCollage={showPhotoCollage}
        viewingSelf={isViewingSelf}
      />
    </div>
  )
}

export default ClosetItem
